import "./VoteSection.scss"

import React, { useEffect, useState } from "react"
import { Post, PostStatus, Vote } from "@fider/models"
import { actions } from "@fider/services"
import { Avatar, Button, Icon, SignInModal } from "@fider/components"
import { useFider } from "@fider/hooks"
import IconThumbsUp from "@fider/assets/images/heroicons-thumbsup.svg"
import IconCheck from "@fider/assets/images/heroicons-check.svg"
import { Trans } from "@lingui/react/macro"
import { VotesModal } from "./VotesModal"

// Tùy biến KHCN: thanh bình chọn gọn ngay trong bài thay cho cột "Người bình chọn" bên trái.
// Mặc định chỉ hiện số lượt và vài ảnh đại diện; bấm vào thì mở danh sách đầy đủ.

interface VoteSectionProps {
  post: Post
  votes: number
  voters?: Vote[]
  onDataChanged?: () => void
}

const MAX_AVATARS = 3

export const VoteSection = (props: VoteSectionProps) => {
  const fider = useFider()
  const [votes, setVotes] = useState(props.votes)
  const [hasVoted, setHasVoted] = useState(props.post.hasVoted)
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)
  const [isVotersOpen, setIsVotersOpen] = useState(false)

  // Số lượt có thể đổi từ ngoài (cập nhật thời gian thực)
  useEffect(() => setVotes(props.votes), [props.votes])
  useEffect(() => setHasVoted(props.post.hasVoted), [props.post.hasVoted])

  const voteOrUndo = async () => {
    if (!fider.session.isAuthenticated) {
      setIsSignInModalOpen(true)
      return
    }

    const action = hasVoted ? actions.removeVote : actions.addVote
    const response = await action(props.post.number)
    if (response.ok) {
      setVotes(hasVoted ? votes - 1 : votes + 1)
      setHasVoted(!hasVoted)
      props.onDataChanged?.()
    }
  }

  const status = PostStatus.Get(props.post.status)
  const isDisabled = status.closed || fider.isReadOnly
  const voters = props.voters ?? []
  const canOpenVoters = votes > 0

  return (
    <>
      <SignInModal isOpen={isSignInModalOpen} onClose={() => setIsSignInModalOpen(false)} />
      <VotesModal post={props.post} isOpen={isVotersOpen} onClose={() => setIsVotersOpen(false)} />
      <div className="c-vote-bar">
        {fider.session.isAuthenticated && (
          <Button variant={hasVoted ? "secondary" : "primary"} onClick={voteOrUndo} disabled={isDisabled} className="c-vote-bar__button">
            <Icon sprite={hasVoted ? IconCheck : IconThumbsUp} />
            <span>{hasVoted ? <Trans id="action.voted">Voted!</Trans> : <Trans id="action.vote">Vote for this idea</Trans>}</span>
          </Button>
        )}
        <button type="button" className="c-vote-bar__voters" onClick={() => canOpenVoters && setIsVotersOpen(true)} disabled={!canOpenVoters}>
          {voters.length > 0 && (
            <span className="c-vote-bar__avatars" aria-hidden="true">
              {voters.slice(0, MAX_AVATARS).map((vote) => (
                <Avatar key={vote.user.id} user={vote.user} size="small" />
              ))}
            </span>
          )}
          <span className="c-vote-bar__count">{votes}</span>
          <span className="c-vote-bar__label">{votes === 1 ? <Trans id="label.vote">Vote</Trans> : <Trans id="label.votes">Votes</Trans>}</span>
        </button>
      </div>
    </>
  )
}
